//
//
//
//
//
//
//

export default {
  name: 'HalfCircleSpinner',

  props: {
    animationDuration: {
      type: Number,
      default: 1000
    },
    size: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#fff'
    }
  },

  computed: {
    spinnerStyle () {
      return {
        height: `${this.size}px`,
        width: `${this.size}px`
      }
    },

    circleStyle () {
      return {
        borderWidth: `${this.size / 10}px`,
        animationDuration: `${this.animationDuration}ms`
      }
    },

    circle1Style () {
      return Object.assign({
        borderTopColor: this.color
      }, this.circleStyle)
    },

    circle2Style () {
      return Object.assign({
        borderBottomColor: this.color
      }, this.circleStyle)
    }
  }
}
